var _desc, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Canvas",
    transform: "translate(7630 -33543)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path0_fill",
    transform: "translate(-7630 33543)",
    fill: "#FFFFFF"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path0_fill",
    d: "M 7.28571 6L 11.7101 1.56632C 12.063 1.21263 12.063 0.618944 11.7101 0.26526C 11.3571 -0.0884241 10.7647 -0.0884241 10.4118 0.26526L 5.9874 4.69895L 1.56303 0.26526C 1.21009 -0.0884241 0.617644 -0.0884241 0.264703 0.26526C -0.0882384 0.618944 -0.0882384 1.21263 0.264703 1.56632L 4.68908 6L 0.264703 10.4337C -0.0882384 10.7874 -0.0882384 11.3811 0.264703 11.7347C 0.441173 11.9116 0.680671 12 0.920167 12C 1.15966 12 1.38655 11.9116 1.57563 11.7347L 6 7.30105L 10.4244 11.7347C 10.6008 11.9116 10.8403 12 11.0798 12C 11.3193 12 11.5462 11.9116 11.7353 11.7347C 12.0882 11.3811 12.0882 10.7874 11.7353 10.4337L 7.28571 6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconWhite);
export default __webpack_public_path__ + "static/media/close-icon-white.033a08e8bb4d722a25ed63a10f9ca61f.svg";
export { ForwardRef as ReactComponent };